import { CalendarDays } from "@acto/web-common/components";
import {
  SelectMenu,
  type SelectMenuProps,
  type SelectOption,
} from "@acto/taskpane/field-sales-2/components/primitives/SelectMenu";

// Calendar-flavoured wrapper around the generic `SelectMenu`: adds a calendar icon per option
// (the month/day-picker case). Non-calendar menus (breakdown/view toggles) should use `SelectMenu`
// directly instead of reaching for this component with `showItemIcons={false}`.

export type CalendarSelectOption = SelectOption;

// Omit per union branch, so each variant keeps its own trigger props.
type SelectMenuPropsWithoutItemIcon = SelectMenuProps extends infer Branch
  ? Branch extends unknown
    ? Omit<Branch, "itemIcon">
    : never
  : never;

type CalendarSelectMenuProps = SelectMenuPropsWithoutItemIcon & {
  /** Show a calendar icon next to each option (default true). */
  showItemIcons?: boolean;
};

export function CalendarSelectMenu({ showItemIcons = true, ...props }: CalendarSelectMenuProps) {
  return <SelectMenu {...props} itemIcon={showItemIcons ? CalendarDays : undefined} />;
}
